module.exports = __webpack_public_path__ + "resources/rank_num_4.b42c47a8103dcf94.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/rank_num_4.png
// module id = 543
// module chunks = 0 1 2 3